exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-items-pane ul[data-v-c4110444]{-webkit-padding-start:6px;padding-inline-start:6px;padding-left:6px}li.ghost[data-v-c4110444]{background:#fff;border:2px dotted #409eff}.drag-option[data-v-c4110444]{cursor:move}.small-padding-dialog[data-v-c4110444]  .el-dialog__body{padding:10px 15px}.dialog-footer .el-button[data-v-c4110444]{width:100px}\n", ""]);

// exports
